import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39f2995e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=39f2995e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2995e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RentalCard: require('/workspace/components/RentalCard.vue').default,RentalCardV3: require('/workspace/components/RentalCardV3.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
